module.exports = __webpack_public_path__ + "static/img/feature_2.982dfd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/feature_2.svg
// module id = k50M
// module chunks = 0